module.exports = __webpack_public_path__ + "static/media/yourdata_02.4aedfbee.jpg";